import Icon from '../components/Icon.vue'

Icon.register({
  'phone-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM94 416c160.1 0 290-129.7 290-290v0c0-6.6-5.2-13.1-11.6-14.6l-65-15c-0.9-0.2-2.4-0.4-3.4-0.4-5.5 0-11.6 4.1-13.8 9.1l-30 70c-0.7 1.6-1.2 4.2-1.2 5.9 0 3.9 2.5 9.1 5.5 11.6l37.9 31c-22.5 47.9-61.8 87.8-110.8 110.8l-31-37.9c-2.5-3-7.7-5.5-11.6-5.5-1.7 0-4.3 0.5-5.9 1.2l-70 30c-5 2.2-9.1 8.3-9.1 13.8 0 0.9 0.2 2.5 0.4 3.4l15 65c1.6 6.8 7.6 11.6 14.6 11.6z'
      }
    ]
  }
})
